import axiosInstance from './AxiosInstance';
const empUrl = "api/employee"
const userUrl = "api/user"
const designationUrl = "api/designation"
const unitUrl = "api/unit"
const sourceUrl = "api/source"
const departmentUrl = "api/department"
const prodCatUrl = "api/product_category"
const requisitionUrl = "api/requisitions"
const reservationUrl = "api/reservations"

// user
export function getUserList(page, page_size, query) {
    return axiosInstance.get(`${userUrl}?page=${page}&page_size=${page_size}&query=${query}`);
}

export function getUser(empId) {
    return axiosInstance.get(`${userUrl}/${empId}`);
}

export function createUser(empData) {
    return axiosInstance.post(userUrl, empData);
}

export function updateUser(empData) {
    return axiosInstance.put(userUrl, empData);
}

export function deleteUser(empId) {
    return axiosInstance.delete(`${userUrl}/${empId}`);
}

// employee

export function getEmployeeList(page, page_size, query) {
    return axiosInstance.get(`${empUrl}?page=${page}&page_size=${page_size}&query=${query}`);
}

export function getEmployee(empId) {
    return axiosInstance.get(`${empUrl}/${empId}`);
}

export function createEmployee(empData) {
    return axiosInstance.post(empUrl, empData);
}

export function updateEmployee(empData) {
    return axiosInstance.put(empUrl, empData);
}

export function deleteEmployee(empId) {
    return axiosInstance.delete(`${empUrl}/${empId}`);
}

// requisition

export function getRequisitionList(filter) {
    const params = new URLSearchParams({
        ...filter, 
    });
    return axiosInstance.get(`${requisitionUrl}?${params.toString()}`);
}

export function getRequisitionStockoutItem(requisitionId) {
    return axiosInstance.get(`api/requisition_stockout_item/${requisitionId}`);
}

export function stockOutRequisitionItem(requisitionId, data) {
    return axiosInstance.put(`api/requisition_stockout_item/${requisitionId}`, data);
}


export function getRequisition(requisitionId) {
    return axiosInstance.get(`${requisitionUrl}/${requisitionId}`);
}

export function createRequisition(reqData) {
    return axiosInstance.post(requisitionUrl, reqData);
}

export function updateRequisition(reqData) {
    return axiosInstance.put(requisitionUrl, reqData);
}

export function cancelRequisition(requisitionId) {
    return axiosInstance.patch(`${requisitionUrl}/${requisitionId}`);
}

// requisition

export function getReservationStockinItem(reservationId) {
    return axiosInstance.get(`api/reservation_stockin_item/${reservationId}`);
}

export function stockInReservationItem(reservationId, data) {
    return axiosInstance.post(`api/reservation_stockin_item/${reservationId}`, data);
}

export function getReservationList(filter) {
    const params = new URLSearchParams({
        ...filter, 
    });
    return axiosInstance.get(`${reservationUrl}?${params.toString()}`);
}

export function getReservation(reservationId) {
    return axiosInstance.get(`${reservationUrl}/${reservationId}`);
}

export function createReservation(reqData) {
    return axiosInstance.post(reservationUrl, reqData);
}

export function updateReservation(reqData) {
    return axiosInstance.put(reservationUrl, reqData);
}

export function cancelReservation(reservationId) {
    return axiosInstance.patch(`${reservationUrl}/${reservationId}`);
}

// designation

export function getDesignationList() {
    return axiosInstance.get(`${designationUrl}`);
}

export function createDesignation(Data) {
    return axiosInstance.post(designationUrl, Data);
}

export function updateDesignation(Data) {
    return axiosInstance.put(designationUrl, Data);
}

// unit

export function getUnitList() {
    return axiosInstance.get(`${unitUrl}`);
}

export function createUnit(Data) {
    return axiosInstance.post(unitUrl, Data);
}

export function updateUnit(Data) {
    return axiosInstance.put(unitUrl, Data);
}

// source

export function getSourceList() {
    return axiosInstance.get(`${sourceUrl}`);
}

export function createSource(Data) {
    return axiosInstance.post(sourceUrl, Data);
}

export function updateSource(Data) {
    return axiosInstance.put(sourceUrl, Data);
}


// department

export function getDepartmentList() {
    return axiosInstance.get(`${departmentUrl}`);
}


export function createDepartment(Data) {
    return axiosInstance.post(departmentUrl, Data);
}

export function updateDepartment(Data) {
    return axiosInstance.put(departmentUrl, Data);
}

// product Catgory

export function getProductCategoryList() {
    return axiosInstance.get(`${prodCatUrl}`);
}

export function createProductCategory(Data) {
    return axiosInstance.post(prodCatUrl, Data);
}

export function updateProductCategory(Data) {
    return axiosInstance.put(prodCatUrl, Data);
}

export function getAuthorized() {
    return axiosInstance.get('api/user/authorized');
}

export function generateStockData(Data) {
    return axiosInstance.post("api/generate_stock_data", Data);
}


export function sendDailyReportMailApi() {
    return axiosInstance.get("api/instant_send_daily_report");
}